import React from 'react'
import {connect} from 'react-redux'
import Titulo from '../comum/Titulo';
import {getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa, PERFIL_ADMIN} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import {alterouFiltro, alterouPagina} from '../../util/filtros';
import buscarAgencias from '../../actions/agencia/buscarAgencias';
import excluirAgencia from '../../actions/agencia/excluirAgencia';
import selecionarAgencia from '../../actions/agencia/selecionarAgencia';
import PaginacaoAgencia from './PaginacaoAgencia';
import BotoesPaginacaoAgencia from './BotoesPaginacaoAgencia';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import PainelFiltragem from './PainelFiltrosAgencia';
import Agencia from './Agencia';
import ModalCadastrarAgencia from './ModalCadastrarAgencia';
import bloquearAgencia from '../../actions/agencia/bloquearAgencia';
import desbloquearAgencia from '../../actions/agencia/desbloquearAgencia';
import {showSuccessMsg} from '../../util/messagesUtil';

export const CabecalhoTabela = () => (
    <div className="vx-list-header vx-list-header--agencia">
        <div className="vx-list-header-cell"></div>
        <div className="vx-list-header-cell">Número</div>
        <div className="vx-list-header-cell">Nome</div>
        <div className="vx-list-header-cell">CNPJ</div>
        <div className="vx-list-header-cell">Localidade</div>
        <div className="vx-list-header-cell">UF</div>
        <div className="vx-list-header-cell">Logradouro</div>
        <div className="vx-list-header-cell">Bairro</div>
        <div className="vx-list-header-cell">CEP</div>
        <div className="vx-list-header-cell">Ações</div>
    </div>
);

const ModalConfirmacaoBloqueioAgencia = ({bloquearDesbloquear, agencia}) => (
    <div className="modal fade" id="modalConfirmacaoBloqueioAgencia" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacaoBloqueioAgencia" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
            <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
                <div className="vx-modal-header">
                    <div className="vx-modal-title">
                        <span className="material-icons">{agencia && agencia.bloqueada ? 'lock_open' : 'lock'}</span>
                        {agencia && agencia.bloqueada ? 'Desbloquear' : 'Bloquear'} Agência
                    </div>
                </div>
                <div className="vx-modal-body" style={{ background: '#fff', textAlign: 'center' }}>
                    <p style={{ margin: 0, fontSize: 14, color: '#444' }}>
                        Deseja {agencia && agencia.bloqueada ? 'desbloquear' : 'bloquear'} a agência{' '}
                        <strong>{agencia ? agencia.nome : ''}</strong>?
                    </p>
                </div>
                <div className="vx-modal-footer">
                    <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal">Cancelar</button>
                    <button type="button" className="vx-modal-btn-confirmar" data-dismiss="modal"
                            onClick={() => bloquearDesbloquear()}>
                        <span className="material-icons" style={{ fontSize: 15 }}>
                            {agencia && agencia.bloqueada ? 'lock_open' : 'lock'}
                        </span>
                        Confirmar
                    </button>
                </div>
            </div>
        </div>
    </div>
);

const ModalConfirmacaoExclusao = ({excluir, agencia}) => (
    <div className="modal fade" id="modalConfirmacaoExclusaoAgencia" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacaoExclusaoAgencia" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
            <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
                <div className="vx-modal-header">
                    <div className="vx-modal-title">
                        <span className="material-icons">delete</span>
                        Excluir Agência
                    </div>
                </div>
                <div className="vx-modal-body" style={{ background: '#fff', textAlign: 'center' }}>
                    <p style={{ margin: 0, fontSize: 14, color: '#444' }}>
                        Deseja excluir a agência <strong>{agencia ? agencia.nome : ''}</strong>?
                    </p>
                </div>
                <div className="vx-modal-footer">
                    <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal">Cancelar</button>
                    <button type="button" className="vx-modal-btn-confirmar" data-dismiss="modal"
                            onClick={() => excluir()}>
                        <span className="material-icons" style={{ fontSize: 15 }}>delete</span>
                        Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>
);

export class PainelGerenciarAgencias extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            parametros: { nome: '', uf: '' }
        };
    }

    componentDidMount() {
        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.buscarAgencias();
        }
    }

    componentDidUpdate(prevProps) {
        if (alterouPagina(this.props, prevProps) || alterouFiltro(this.props, prevProps) || this.props.empresaSelecionada !== prevProps.empresaSelecionada) {
            this.buscarAgencias();
        }
    }

    bloquearDesbloquear() {
        if (this.props.agenciaSelecionada.bloqueada) {
            this.props.desbloquearAgencia(this.props.agenciaSelecionada.id, this.props.empresaSelecionada.id)
                .then(response => {
                    if (response.payload.status == 200) {
                        this.props.buscarAgencias(this.props.empresaSelecionada.id);
                    }
                })
        } else {
            this.props.bloquearAgencia(this.props.agenciaSelecionada.id, this.props.empresaSelecionada.id)
                .then(response => {
                    if (response.payload.status == 200) {
                        this.props.buscarAgencias(this.props.empresaSelecionada.id);
                    }
                })
        }
    }

    buscarAgencias() {
        this.props.buscarAgencias(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    excluir() {
        this.props.excluirAgencia(this.props.agenciaSelecionada.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Agência excluída com sucesso');
                this.buscarAgencias();
            })
    }

    exibir() {
        if (this.props.agencias && this.props.agencias.length) {
            return (
                <div className="vx-list-container">
                    <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoAgencia}
                                           BotoesPaginacao={BotoesPaginacaoAgencia}>
                        <CabecalhoTabela />
                        {this.exibirAgencias()}
                    </CabecalhoRodapeTabela>
                </div>
            )
        }
        return (
            <div className="vx-list-container">
                <div className="vx-empty-state">
                    <span className="material-icons">search</span>
                    <p>Nenhuma agência encontrada</p>
                </div>
            </div>
        );
    }

    exibirAgencias() {
        if (this.props.agencias) {
            return this.props.agencias.map(agencia => (
                <Agencia key={agencia.id} agencia={agencia} idEmpresa={this.props.empresaSelecionada.id} />
            ))
        }
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="row internas">
                    <Titulo texto="Gerenciar Agências" urlRetorno="/" />
                    <div className="col-12 conteudo-internas conteudo-painel area-btn-filtro-painel">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 12, marginBottom: 8 }}>
                            <PainelFiltragem />
                            <button
                                data-toggle="modal"
                                data-target="#modalCadastrarAgencia"
                                className="vx-toolbar-btn"
                                onClick={() => this.props.selecionarAgencia()}>
                                <span className="material-icons" style={{ fontSize: 16 }}>add</span>
                                Nova Agência
                            </button>
                        </div>
                        {this.exibir()}
                    </div>
                </div>
                <ModalCadastrarAgencia parametros={this.state.parametros}
                                       buscarAgencias={this.buscarAgencias.bind(this)} />
                <ModalConfirmacaoExclusao excluir={this.excluir.bind(this)} agencia={this.props.agenciaSelecionada} />
                <ModalConfirmacaoBloqueioAgencia bloquearDesbloquear={this.bloquearDesbloquear.bind(this)}
                                                 agencia={this.props.agenciaSelecionada} />
            </Autorizacao>
        )
    }
}

export const mapStateToProps = state => ({
    agencias: state.agencias.agencias,
    agenciaSelecionada: state.agencias.agenciaSelecionada,
    empresaSelecionada: state.empresaSelecionada,
    paginaAtual: state.paginaAtualAgencia,
    registrosPorPagina: state.registrosPorPaginaAgencia,
    filtrosAdicionados: state.filtrosAdicionadosAgencia
});

export default connect(mapStateToProps, {
    buscarAgencias,
    excluirAgencia,
    selecionarAgencia,
    desbloquearAgencia,
    bloquearAgencia
})(PainelGerenciarAgencias)
